import { lazy } from 'react'

// Passenger Bus Management
const PassengerBusList = lazy(() => import('../../views/passenger-bus/buses/list'))
const PassengerBusAdd = lazy(() => import('../../views/passenger-bus/buses/add'))
const PassengerBusEdit = lazy(() => import('../../views/passenger-bus/buses/edit'))
const PassengerBusView = lazy(() => import('../../views/passenger-bus/buses/view'))

// Operator Management
const OperatorList = lazy(() => import('../../views/passenger-bus/operators/list'))
const OperatorAdd = lazy(() => import('../../views/passenger-bus/operators/add'))
const OperatorEdit = lazy(() => import('../../views/passenger-bus/operators/edit'))
const OperatorView = lazy(() => import('../../views/passenger-bus/operators/view'))
const PendingOperators = lazy(() => import('../../views/passenger-bus/operators/pending'))

// Routes Management
const RouteList = lazy(() => import('../../views/passenger-bus/routes/list'))
const RouteAdd = lazy(() => import('../../views/passenger-bus/routes/add'))
const RouteEdit = lazy(() => import('../../views/passenger-bus/routes/edit'))
const RouteView = lazy(() => import('../../views/passenger-bus/routes/view'))

// Route Proposals Management
const RouteProposalList = lazy(() => import('../../views/passenger-bus/route-proposals/list'))
const RouteProposalAdd = lazy(() => import('../../views/passenger-bus/route-proposals/add'))
const RouteProposalEdit = lazy(() => import('../../views/passenger-bus/route-proposals/edit'))
const RouteProposalView = lazy(() => import('../../views/passenger-bus/route-proposals/view'))

// Route Applications Management
const RouteApplicationList = lazy(() => import('../../views/passenger-bus/route-applications'))
const RouteApplicationView = lazy(() => import('../../views/passenger-bus/route-applications/view'))
const RouteApplicationDecision = lazy(() => import('../../views/passenger-bus/route-applications/decision'))
const RouteApplicationDecisionView = lazy(() => import('../../views/passenger-bus/route-applications/decision-view'))
const PastApplications = lazy(() => import('../../views/passenger-bus/route-applications/past-applications'))

// Route Permits Management
const RoutePermitList = lazy(() => import('../../views/passenger-bus/route-permits/list'))
const RoutePermitView = lazy(() => import('../../views/passenger-bus/route-permits/view'))
const RoutePermitDecision = lazy(() => import('../../views/passenger-bus/route-permits/decision'))
const RoutePermitRenewal = lazy(() => import('../../views/passenger-bus/route-permits/renewal'))
const RoutePermitSuspension = lazy(() => import('../../views/passenger-bus/route-permits/suspension'))

// Route Suspensions Management
const RouteSuspensionList = lazy(() => import('../../views/passenger-bus/route-suspensions/list'))
const RouteSuspensionView = lazy(() => import('../../views/passenger-bus/route-suspensions/view'))
const RouteSuspensionDecision = lazy(() => import('../../views/passenger-bus/route-suspensions/decision'))
const RouteSuspensionReinstate = lazy(() => import('../../views/passenger-bus/route-suspensions/reinstate'))

// Route Cancellations Management
const RouteCancellationList = lazy(() => import('../../views/passenger-bus/route-cancellations/list'))
const RouteCancellationView = lazy(() => import('../../views/passenger-bus/route-cancellations/view'))
const RouteCancellationDecision = lazy(() => import('../../views/passenger-bus/route-cancellations/decision'))

// Fleet Management
const FleetList = lazy(() => import('../../views/passenger-bus/fleet/list'))
const FleetAdd = lazy(() => import('../../views/passenger-bus/fleet/add'))
const FleetView = lazy(() => import('../../views/passenger-bus/fleet/view'))

// Bus Inspections Management
const BusInspectionsManagement = lazy(() => import('../../views/passenger-bus/bus-inspections'))
const BusInspectionApplicationsList = lazy(() => import('../../views/passenger-bus/bus-inspections/applications'))
const BusInspectionApplicationView = lazy(() => import('../../views/passenger-bus/bus-inspections/applications/view'))
const BusInspectionPage = lazy(() => import('../../views/passenger-bus/bus-inspections/applications/inspect'))
const ViewInspectionReport = lazy(() => import('../../views/passenger-bus/bus-inspections/applications/view-report'))
const BusInspectionsList = lazy(() => import('../../views/passenger-bus/bus-inspections/list'))
const BusInspectionView = lazy(() => import('../../views/passenger-bus/bus-inspections/view'))
const BusInspectionReports = lazy(() => import('../../views/passenger-bus/bus-inspections/reports'))

// Bus Types
const BusTypeList = lazy(() => import('../../views/passenger-bus/bus-types/list'))
const BusTypeAdd = lazy(() => import('../../views/passenger-bus/bus-types/add'))
const BusTypeEdit = lazy(() => import('../../views/passenger-bus/bus-types/edit'))
const BusTypeView = lazy(() => import('../../views/passenger-bus/bus-types/view'))

// Drivers Management
const DriverList = lazy(() => import('../../views/passenger-bus/drivers/list'))
const DriverAdd = lazy(() => import('../../views/passenger-bus/drivers/add'))
const DriverEdit = lazy(() => import('../../views/passenger-bus/drivers/edit'))
const DriverView = lazy(() => import('../../views/passenger-bus/drivers/view'))

// Conductors Management
const ConductorList = lazy(() => import('../../views/passenger-bus/conductors/list'))
const ConductorAdd = lazy(() => import('../../views/passenger-bus/conductors/add'))
const ConductorEdit = lazy(() => import('../../views/passenger-bus/conductors/edit'))
const ConductorView = lazy(() => import('../../views/passenger-bus/conductors/view'))

// Route Schedules Management
const RouteScheduleList = lazy(() => import('../../views/passenger-bus/route-schedules/list'))
const RouteScheduleAdd = lazy(() => import('../../views/passenger-bus/route-schedules/add'))
const RouteScheduleEdit = lazy(() => import('../../views/passenger-bus/route-schedules/edit'))
const RouteScheduleView = lazy(() => import('../../views/passenger-bus/route-schedules/view'))

// Places Management
const PlaceList = lazy(() => import('../../views/passenger-bus/places/list'))
const PlaceAdd = lazy(() => import('../../views/passenger-bus/places/add'))
const PlaceEdit = lazy(() => import('../../views/passenger-bus/places/edit'))
const PlaceView = lazy(() => import('../../views/passenger-bus/places/view'))

// Road Types Management
const RoadTypeList = lazy(() => import('../../views/passenger-bus/road-types/list'))
const RoadTypeAdd = lazy(() => import('../../views/passenger-bus/road-types/add'))
const RoadTypeEdit = lazy(() => import('../../views/passenger-bus/road-types/edit'))
const RoadTypeView = lazy(() => import('../../views/passenger-bus/road-types/view'))

// Road Conditions Management
const RoadConditionList = lazy(() => import('../../views/passenger-bus/road-conditions/list'))
const RoadConditionAdd = lazy(() => import('../../views/passenger-bus/road-conditions/add'))
const RoadConditionEdit = lazy(() => import('../../views/passenger-bus/road-conditions/edit'))
const RoadConditionView = lazy(() => import('../../views/passenger-bus/road-conditions/view'))

// Drive Types Management
const DriveTypeList = lazy(() => import('../../views/passenger-bus/drive-types/list'))
const DriveTypeAdd = lazy(() => import('../../views/passenger-bus/drive-types/add'))
const DriveTypeEdit = lazy(() => import('../../views/passenger-bus/drive-types/edit'))
const DriveTypeView = lazy(() => import('../../views/passenger-bus/drive-types/view'))

// Dzongkhags Management (Passenger Bus)
const DzongkhagList = lazy(() => import('../../views/passenger-bus/dzongkhags/list'))
const DzongkhagAdd = lazy(() => import('../../views/passenger-bus/dzongkhags/add'))
const DzongkhagEdit = lazy(() => import('../../views/passenger-bus/dzongkhags/edit'))
const DzongkhagView = lazy(() => import('../../views/passenger-bus/dzongkhags/view'))

// Gewogs Management (Passenger Bus)
const GewogList = lazy(() => import('../../views/passenger-bus/gewogs/list'))
const GewogAdd = lazy(() => import('../../views/passenger-bus/gewogs/add'))
const GewogEdit = lazy(() => import('../../views/passenger-bus/gewogs/edit'))
const GewogView = lazy(() => import('../../views/passenger-bus/gewogs/view'))

// Legacy Routes Management
const LegacyRouteList = lazy(() => import('../../views/passenger-bus/legacy-routes/list'))
const LegacyRouteAdd = lazy(() => import('../../views/passenger-bus/legacy-routes/add'))
const LegacyRouteUpload = lazy(() => import('../../views/passenger-bus/legacy-routes/upload'))
const LegacyRouteView = lazy(() => import('../../views/passenger-bus/legacy-routes/view'))
const LegacyRouteEdit = lazy(() => import('../../views/passenger-bus/legacy-routes/edit'))

const BroadcastToOperators = lazy(() => import('../../views/passenger-bus/broadcast'))

const PassengerBusRoutes = [
  {
    path: '/passenger-bus/buses',
    element: <PassengerBusList />,
    meta: { action: 'read', resource: 'PBPassengerBus' }
  },
  {
    path: '/passenger-bus/buses/new',
    element: <PassengerBusAdd />,
    meta: { action: 'create', resource: 'PBPassengerBus' }
  },
  {
    path: '/passenger-bus/buses/:id/view',
    element: <PassengerBusView />,
    meta: { action: 'read', resource: 'PBPassengerBus' }
  },
  {
    path: '/passenger-bus/buses/:id/edit',
    element: <PassengerBusEdit />,
    meta: { action: 'update', resource: 'PBPassengerBus' }
  },
  {
    path: '/passenger-bus/operators',
    element: <OperatorList />,
    meta: { action: 'read', resource: 'PBOperator' }
  },
  {
    path: '/passenger-bus/operators/new',
    element: <OperatorAdd />,
    meta: { action: 'create', resource: 'PBOperator' }
  },
  {
    path: '/passenger-bus/operators/:id/view',
    element: <OperatorView />,
    meta: { action: 'read', resource: 'PBOperator' }
  },
  {
    path: '/passenger-bus/operators/:id/edit',
    element: <OperatorEdit />,
    meta: { action: 'update', resource: 'PBOperator' }
  },
  {
    path: '/passenger-bus/operators/pending',
    element: <PendingOperators />,
    meta: { action: 'read', resource: 'PBOperator' }
  },
  // Routes
  {
    path: '/passenger-bus/routes',
    element: <RouteList />,
    meta: { action: 'read', resource: 'PBRoute' }
  },
  {
    path: '/passenger-bus/routes/new',
    element: <RouteAdd />,
    meta: { action: 'create', resource: 'PBRoute' }
  },
  {
    path: '/passenger-bus/routes/:id/view',
    element: <RouteView />,
    meta: { action: 'read', resource: 'PBRoute' }
  },
  {
    path: '/passenger-bus/routes/:id/edit',
    element: <RouteEdit />,
    meta: { action: 'update', resource: 'PBRoute' }
  },
  // Route Proposals
  {
    path: '/passenger-bus/route-proposals',
    element: <RouteProposalList />,
    meta: { action: 'read', resource: 'PBRouteProposal' }
  },
  {
    path: '/passenger-bus/route-proposals/new',
    element: <RouteProposalAdd />,
    meta: { action: 'create', resource: 'PBRouteProposal' }
  },
  {
    path: '/passenger-bus/route-proposals/:id/view',
    element: <RouteProposalView />,
    meta: { action: 'read', resource: 'PBRouteProposal' }
  },
  {
    path: '/passenger-bus/route-proposals/:id/edit',
    element: <RouteProposalEdit />,
    meta: { action: 'update', resource: 'PBRouteProposal' }
  },
  // Route Applications
  {
    path: '/passenger-bus/route-applications',
    element: <RouteApplicationList />,
    meta: { action: 'read', resource: 'PBRouteApplication', navLink: '/passenger-bus/route-applications' }
  },
  {
    path: '/passenger-bus/route-applications/:id/view',
    element: <RouteApplicationView />,
    meta: { action: 'read', resource: 'PBRouteApplication', navLink: '/passenger-bus/route-applications' }
  },
  {
    path: '/passenger-bus/route-applications/:id/decision',
    element: <RouteApplicationDecision />,
    meta: { action: 'update', resource: 'PBRouteApplication', navLink: '/passenger-bus/route-applications' }
  },
  {
    path: '/passenger-bus/route-applications/:id/decision-view',
    element: <RouteApplicationDecisionView />,
    meta: { action: 'read', resource: 'PBRouteApplication', navLink: '/passenger-bus/route-applications' }
  },
  {
    path: '/passenger-bus/route-applications/past',
    element: <PastApplications />,
    meta: { action: 'read', resource: 'PBRouteApplication', navLink: '/passenger-bus/route-applications/past' }
  },
  // Route Permits
  {
    path: '/passenger-bus/route-permits',
    element: <RoutePermitList />,
    meta: { action: 'read', resource: 'PBRoutePermit' }
  },
  {
    path: '/passenger-bus/route-permits/:id/view',
    element: <RoutePermitView />,
    meta: { action: 'read', resource: 'PBRoutePermit', navLink: '/passenger-bus/route-permits' }
  },
  {
    path: '/passenger-bus/route-permits/:id/decision',
    element: <RoutePermitDecision />,
    meta: { action: 'update', resource: 'PBRoutePermit', navLink: '/passenger-bus/route-permits' }
  },
  {
    path: '/passenger-bus/route-permits/:id/renewal',
    element: <RoutePermitRenewal />,
    meta: { action: 'update', resource: 'PBRoutePermit', navLink: '/passenger-bus/route-permits' }
  },
  {
    path: '/passenger-bus/route-permits/:id/suspension',
    element: <RoutePermitSuspension />,
    meta: { action: 'update', resource: 'PBRoutePermit', navLink: '/passenger-bus/route-permits' }
  },
  // Route Suspensions
  {
    path: '/passenger-bus/route-suspensions',
    element: <RouteSuspensionList />,
    meta: { action: 'read', resource: 'PBRouteSuspension' }
  },
  {
    path: '/passenger-bus/route-suspensions/:id/view',
    element: <RouteSuspensionView />,
    meta: { action: 'read', resource: 'PBRouteSuspension', navLink: '/passenger-bus/route-suspensions' }
  },
  {
    path: '/passenger-bus/route-suspensions/:id/decision',
    element: <RouteSuspensionDecision />,
    meta: { action: 'update', resource: 'PBRouteSuspension', navLink: '/passenger-bus/route-suspensions' }
  },
  {
    path: '/passenger-bus/route-suspensions/:id/reinstate',
    element: <RouteSuspensionReinstate />,
    meta: { action: 'update', resource: 'PBRouteSuspension', navLink: '/passenger-bus/route-suspensions' }
  },
  // Route Cancellations
  {
    path: '/passenger-bus/route-cancellations',
    element: <RouteCancellationList />,
    meta: { action: 'read', resource: 'PBRouteCancellation' }
  },
  {
    path: '/passenger-bus/route-cancellations/:id/view',
    element: <RouteCancellationView />,
    meta: { action: 'read', resource: 'PBRouteCancellation', navLink: '/passenger-bus/route-cancellations' }
  },
  {
    path: '/passenger-bus/route-cancellations/:id/decision',
    element: <RouteCancellationDecision />,
    meta: { action: 'update', resource: 'PBRouteCancellation', navLink: '/passenger-bus/route-cancellations' }
  },
  // Fleet Management
  {
    path: '/passenger-bus/fleet',
    element: <FleetList />,
    meta: { action: 'read', resource: 'PBFleet' }
  },
  {
    path: '/passenger-bus/fleet/add',
    element: <FleetAdd />,
    meta: { action: 'create', resource: 'PBFleet' }
  },
  {
    path: '/passenger-bus/fleet/:id/view',
    element: <FleetView />,
    meta: { action: 'read', resource: 'PBFleet', navLink: '/passenger-bus/fleet' }
  },
  // Bus Inspections
  {
    path: '/passenger-bus/bus-inspections',
    element: <BusInspectionsManagement />,
    meta: { action: 'read', resource: 'PBBusInspection' }
  },
  {
    path: '/passenger-bus/bus-inspections/applications',
    element: <BusInspectionApplicationsList />,
    meta: { action: 'read', resource: 'PBBusInspectionApplication' }
  },
  {
    path: '/passenger-bus/bus-inspections/applications/:id/view',
    element: <BusInspectionApplicationView />,
    meta: { action: 'read', resource: 'PBBusInspectionApplication', navLink: '/passenger-bus/bus-inspections/applications' }
  },
  {
    path: '/passenger-bus/bus-inspections/applications/:id/inspect',
    element: <BusInspectionPage />,
    meta: { action: 'create', resource: 'PBBusInspection', navLink: '/passenger-bus/bus-inspections/applications' }
  },
  {
    path: '/passenger-bus/bus-inspections/applications/:id/report',
    element: <ViewInspectionReport />,
    meta: { action: 'read', resource: 'PBBusInspection', navLink: '/passenger-bus/bus-inspections/applications' }
  },
  {
    path: '/passenger-bus/bus-inspections/list',
    element: <BusInspectionsList />,
    meta: { action: 'read', resource: 'PBBusInspection' }
  },
  {
    path: '/passenger-bus/bus-inspections/:id/view',
    element: <BusInspectionView />,
    meta: { action: 'read', resource: 'PBBusInspection' }
  },
  {
    path: '/passenger-bus/bus-inspections/reports',
    element: <BusInspectionReports />,
    meta: { action: 'read', resource: 'PBBusInspection' }
  },
  // Bus Types
  {
    path: '/passenger-bus/bus-types',
    element: <BusTypeList />,
    meta: { action: 'read', resource: 'PBBusType' }
  },
  {
    path: '/passenger-bus/bus-types/new',
    element: <BusTypeAdd />,
    meta: { action: 'create', resource: 'PBBusType' }
  },
  {
    path: '/passenger-bus/bus-types/:id/view',
    element: <BusTypeView />,
    meta: { action: 'read', resource: 'PBBusType' }
  },
  {
    path: '/passenger-bus/bus-types/:id/edit',
    element: <BusTypeEdit />,
    meta: { action: 'update', resource: 'PBBusType' }
  },
  // Drivers
  {
    path: '/passenger-bus/drivers',
    element: <DriverList />,
    meta: { action: 'read', resource: 'PBDriver' }
  },
  {
    path: '/passenger-bus/drivers/new',
    element: <DriverAdd />,
    meta: { action: 'create', resource: 'PBDriver' }
  },
  {
    path: '/passenger-bus/drivers/:id/view',
    element: <DriverView />,
    meta: { action: 'read', resource: 'PBDriver' }
  },
  {
    path: '/passenger-bus/drivers/:id/edit',
    element: <DriverEdit />,
    meta: { action: 'update', resource: 'PBDriver' }
  },
  // Conductors
  {
    path: '/passenger-bus/conductors',
    element: <ConductorList />,
    meta: { action: 'read', resource: 'PBConductor' }
  },
  {
    path: '/passenger-bus/conductors/new',
    element: <ConductorAdd />,
    meta: { action: 'create', resource: 'PBConductor' }
  },
  {
    path: '/passenger-bus/conductors/:id/view',
    element: <ConductorView />,
    meta: { action: 'read', resource: 'PBConductor' }
  },
  {
    path: '/passenger-bus/conductors/:id/edit',
    element: <ConductorEdit />,
    meta: { action: 'update', resource: 'PBConductor' }
  },
  // Route Schedules
  {
    path: '/passenger-bus/route-schedules',
    element: <RouteScheduleList />,
    meta: { action: 'read', resource: 'PBRouteSchedule' }
  },
  {
    path: '/passenger-bus/route-schedules/new',
    element: <RouteScheduleAdd />,
    meta: { action: 'create', resource: 'PBRouteSchedule' }
  },
  {
    path: '/passenger-bus/route-schedules/:id/view',
    element: <RouteScheduleView />,
    meta: { action: 'read', resource: 'PBRouteSchedule' }
  },
  {
    path: '/passenger-bus/route-schedules/:id/edit',
    element: <RouteScheduleEdit />,
    meta: { action: 'update', resource: 'PBRouteSchedule' }
  },
  // Places
  {
    path: '/passenger-bus/places',
    element: <PlaceList />,
    meta: { action: 'read', resource: 'PBPlace' }
  },
  {
    path: '/passenger-bus/places/new',
    element: <PlaceAdd />,
    meta: { action: 'create', resource: 'PBPlace' }
  },
  {
    path: '/passenger-bus/places/:id/view',
    element: <PlaceView />,
    meta: { action: 'read', resource: 'PBPlace' }
  },
  {
    path: '/passenger-bus/places/:id/edit',
    element: <PlaceEdit />,
    meta: { action: 'update', resource: 'PBPlace' }
  },
  // Road Types
  {
    path: '/passenger-bus/road-types',
    element: <RoadTypeList />,
    meta: { action: 'read', resource: 'PBRoadType' }
  },
  {
    path: '/passenger-bus/road-types/new',
    element: <RoadTypeAdd />,
    meta: { action: 'create', resource: 'PBRoadType' }
  },
  {
    path: '/passenger-bus/road-types/:id/view',
    element: <RoadTypeView />,
    meta: { action: 'read', resource: 'PBRoadType' }
  },
  {
    path: '/passenger-bus/road-types/:id/edit',
    element: <RoadTypeEdit />,
    meta: { action: 'update', resource: 'PBRoadType' }
  },
  // Road Conditions
  {
    path: '/passenger-bus/road-conditions',
    element: <RoadConditionList />,
    meta: { action: 'read', resource: 'PBRoadCondition' }
  },
  {
    path: '/passenger-bus/road-conditions/new',
    element: <RoadConditionAdd />,
    meta: { action: 'create', resource: 'PBRoadCondition' }
  },
  {
    path: '/passenger-bus/road-conditions/:id/view',
    element: <RoadConditionView />,
    meta: { action: 'read', resource: 'PBRoadCondition' }
  },
  {
    path: '/passenger-bus/road-conditions/:id/edit',
    element: <RoadConditionEdit />,
    meta: { action: 'update', resource: 'PBRoadCondition' }
  },
  // Drive Types
  {
    path: '/passenger-bus/drive-types',
    element: <DriveTypeList />,
    meta: { action: 'read', resource: 'PBDriveType' }
  },
  {
    path: '/passenger-bus/drive-types/new',
    element: <DriveTypeAdd />,
    meta: { action: 'create', resource: 'PBDriveType' }
  },
  {
    path: '/passenger-bus/drive-types/:id/view',
    element: <DriveTypeView />,
    meta: { action: 'read', resource: 'PBDriveType' }
  },
  {
    path: '/passenger-bus/drive-types/:id/edit',
    element: <DriveTypeEdit />,
    meta: { action: 'update', resource: 'PBDriveType' }
  },
  // Dzongkhags
  {
    path: '/passenger-bus/dzongkhags',
    element: <DzongkhagList />,
    meta: { action: 'read', resource: 'PBDzongkhag' }
  },
  {
    path: '/passenger-bus/dzongkhags/new',
    element: <DzongkhagAdd />,
    meta: { action: 'create', resource: 'PBDzongkhag' }
  },
  {
    path: '/passenger-bus/dzongkhags/:id/view',
    element: <DzongkhagView />,
    meta: { action: 'read', resource: 'PBDzongkhag' }
  },
  {
    path: '/passenger-bus/dzongkhags/:id/edit',
    element: <DzongkhagEdit />,
    meta: { action: 'update', resource: 'PBDzongkhag' }
  },
  // Gewogs
  {
    path: '/passenger-bus/gewogs',
    element: <GewogList />,
    meta: { action: 'read', resource: 'PBGewog' }
  },
  {
    path: '/passenger-bus/gewogs/new',
    element: <GewogAdd />,
    meta: { action: 'create', resource: 'PBGewog' }
  },
  {
    path: '/passenger-bus/gewogs/:id/view',
    element: <GewogView />,
    meta: { action: 'read', resource: 'PBGewog' }
  },
  {
    path: '/passenger-bus/gewogs/:id/edit',
    element: <GewogEdit />,
    meta: { action: 'update', resource: 'PBGewog' }
  },
  // Legacy Routes
  {
    path: '/passenger-bus/legacy-routes',
    element: <LegacyRouteList />,
    meta: { action: 'read', resource: 'PBLegacyRoute' }
  },
  {
    path: '/passenger-bus/legacy-routes/new',
    element: <LegacyRouteAdd />,
    meta: { action: 'create', resource: 'PBLegacyRoute' }
  },
  {
    path: '/passenger-bus/legacy-routes/upload',
    element: <LegacyRouteUpload />,
    meta: { action: 'create', resource: 'PBLegacyRoute' }
  },
  {
    path: '/passenger-bus/legacy-routes/:id/view',
    element: <LegacyRouteView />,
    meta: { action: 'read', resource: 'PBLegacyRoute' }
  },
  {
    path: '/passenger-bus/legacy-routes/:id/edit',
    element: <LegacyRouteEdit />,
    meta: { action: 'update', resource: 'PBLegacyRoute' }
  },
  {
    path: '/passenger-bus/broadcast',
    element: <BroadcastToOperators />,
    meta: { action: 'create', resource: 'PBOperator' }
  }
]

export default PassengerBusRoutes
